import axios from "axios";

export let BASE_URL = process.env.REACT_APP_API_URL;

// export const baseURL =
//   process.env.NODE_ENV === "development"
//     ? "http://localhost:3000"
//     : "https://test-api.spattro.com/";

export const baseURL = BASE_URL;

// Create axios instance
export const instance = axios.create({
  baseURL: BASE_URL,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
